import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-4 col-xl-2 col-xxl-1 pe-md-0 order-0 mt-2" }
const _hoisted_3 = { class: "invalid-feedback" }
const _hoisted_4 = { class: "col-md-4 col-xl-2 col-xxl-1 order-1 mt-2" }
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "col-md-10 col-xl-5 col-xxl-7 ps-xl-0 order-2 order-lg-3 order-xl-2 mt-2" }
const _hoisted_7 = { class: "invalid-feedback" }
const _hoisted_8 = { class: "col-md-4 col-xl-2 order-1 order-lg-2 order-xl-3 ps-md-0 mt-2" }
const _hoisted_9 = { class: "invalid-feedback" }
const _hoisted_10 = { class: "col-md-2 col-xl-1 order-4 ps-md-0 mt-2" }
const _hoisted_11 = {
  class: "d-flex align-items-center justify-content-end rounded-1",
  style: {"padding":".4rem 0"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "bi bi-arrow-up",
  height: "20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
  })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-arrow-down",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  class: "bi bi-x-circle",
  width: "20",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" })
], -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pb-3 mb-2", {'invoice-item-border' : !_ctx.last}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Field, {
        name: `items.${_ctx.item.fieldUid}.id`,
        type: "hidden",
        value: _ctx.item.id
      }, null, 8, ["name", "value"]),
      _createVNode(_component_Field, {
        name: `items.${_ctx.item.fieldUid}.position`,
        type: "hidden",
        value: _ctx.item.position
      }, null, 8, ["name", "value"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Field, {
          name: `items.${_ctx.item.fieldUid}.quantity`,
          class: _normalizeClass([{ 'is-invalid' : _ctx.errors[`items.${_ctx.item.fieldUid}.quantity`] }, "form-control"]),
          value: _ctx.item?.quantity,
          placeholder: "počet"
        }, null, 8, ["name", "class", "value"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errors[`items.${_ctx.item.fieldUid}.quantity`]), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, {
          name: `items.${_ctx.item.fieldUid}.measureUnit`,
          class: _normalizeClass([{ 'is-invalid' : _ctx.errors[`items.${_ctx.item.fieldUid}.measureUnit`] }, "form-control"]),
          value: _ctx.item?.measureUnit,
          placeholder: "hod, ..."
        }, null, 8, ["name", "class", "value"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.errors[`items.${_ctx.item.fieldUid}.measureUnit`]), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Field, {
          name: `items.${_ctx.item.fieldUid}.description`,
          class: _normalizeClass([{ 'is-invalid' : _ctx.errors[`items.${_ctx.item.fieldUid}.description`] }, "form-control"]),
          value: _ctx.item?.description,
          placeholder: "Popis..."
        }, null, 8, ["name", "class", "value"]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.errors[`items.${_ctx.item.fieldUid}.description`]), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Field, {
          name: `items.${_ctx.item.fieldUid}.price`,
          class: _normalizeClass([{ 'is-invalid' : _ctx.errors[`items.${_ctx.item.fieldUid}.price`] }, "form-control"]),
          value: _ctx.item?.price,
          placeholder: "cena"
        }, null, 8, ["name", "class", "value"]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.errors[`items.${_ctx.item.fieldUid}.price`]), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.first)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleMove('UP'))),
                class: "link-secondary border-0 bg-transparent p-0"
              }, _hoisted_13))
            : _createCommentVNode("", true),
          (!_ctx.last)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleMove('DOWN'))),
                class: "link-secondary border-0 bg-transparent p-0"
              }, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.count > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRemove && _ctx.handleRemove(...args)), ["prevent"])),
                class: "link-danger ms-1 border-0 bg-transparent p-0"
              }, _hoisted_17))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}